'use strict'

class OurTeam {
    
    constructor() {
        
    }
    
    init () {
        let tabs = $('nav[class="tabs"] a');
        let data_content = false;
        $('div[class="tab"]').on('click', (e) => {
            if(tabs.is(":hidden") === false){
                return;
            }
            let content_id = $(e.currentTarget).prop('id');
            if (data_content !== content_id){
                $('a[href="#' + content_id + '"').trigger('click');
                $(e.currentTarget).show();
            } else {
                if($(e.currentTarget).hasClass('active')){
                    $(e.currentTarget).removeClass('active');
                } else {
                    $(e.currentTarget).addClass('active');
                }
            }
        });
        tabs.each((i) => {
            $(tabs[i]).on('click', (e) => {
                e.preventDefault();
                $('nav[class="tabs"] a').removeClass('active');
                $('div[data-title]').removeClass('active');

                data_content = $(e.currentTarget).attr('href').replace('#', '');
                
                $(e.currentTarget).addClass('active');
                $('#' + data_content).addClass('active');
            });
        });
        $(tabs[0]).trigger('click');
    }
}

export default OurTeam;